import { showFeedback } from '../../feedback/feedbackReducer';
import { ApiAttributeMapping, mappingsApi } from '../../apis';
import { useMe } from '../../organisation/useMe';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useQueryAttributeMappings = () => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: ['mappings', currentOrganisation?.id],
    queryFn: () => mappingsApi.findAttributeMappings(),
    enabled: !!currentOrganisation,
  });
};

export const useUpdateMappings = () => {
  const queryClient = useQueryClient();
  const { currentOrganisation } = useMe();

  return useMutation({
    mutationFn: (apiAttributeMapping: ApiAttributeMapping) =>
      mappingsApi.updateAttributeMapping({ apiAttributeMapping }),
    onSuccess: async (updatedMapping) => {
      showFeedback({
        message: `Attribute mapping for field ${updatedMapping.field} updated!`,
        success: true,
      });

      await queryClient.invalidateQueries({ queryKey: ['mappings', currentOrganisation?.id] });
    },
  });
};
